import {computed, effect, inject, Injectable, signal} from '@angular/core';
import {CartItem} from "~shared/models/cartitem.model";
import {IProduct} from "~features/home/models/product.model";
import {ShippingInfo} from "~shared/models/shippinginfo.model";
import {takeUntilDestroyed, toObservable} from "@angular/core/rxjs-interop";
import {SessionService} from "~core/services/session.service";
import {ICountry} from "~core/models/countries.model";


@Injectable({
  providedIn: 'root'
})
export class CartService {
  private readonly sessionService = inject(SessionService);

  items = signal<CartItem[]>([]);
  shippingCost = signal(0);
  iva = signal(0);
  iva_shipping = signal(0);
  fees = signal(0);
  customerinfo = signal<ShippingInfo>({} as ShippingInfo);
  ordine_id = signal<string|null>(null);
  shipaddressConfirmed = signal(false);
  insuranceEnabled = signal(false);
  isshippinginfoValid = signal(false)
  sconto = signal(0);
  isscontato = computed(() => this.sconto() > 0);
  iva_reduced=signal(0);
  iva_reduced_2=signal(0);
  payment=signal<string>('cash');


  defaultShippingValues:ShippingInfo = {name:'',surname:'',email:'',phone:'',country:'',address:'',city:'',state:'',zip:'',insurance:false,notes:'',coupon:'',shippingDate:null,marketing_consent:false,privacy_terms_consent:false};

  //determino l'esatta percentuale iva da usare per prodotto

  getProductVatRate(product: IProduct): number {
    console.log('getProductVatRate', product.tax_rate);
    switch (product.tax_rate) {
      case 'reduced':
        console.log('getProductVatRate reduced', this.iva_reduced());
        return this.iva_reduced() > 0 ? this.iva_reduced() : this.iva();
      case 'reduced-2':
        console.log('getProductVatRate reduced-2', this.iva_reduced_2());
        return this.iva_reduced_2() > 0 ? this.iva_reduced_2() : this.iva();
      default:
        return this.iva();
    }
  }

  // Calcolo il prezzo ivato arrotondato da usare nei conteggi e in esposizione (se prezzo ivato è attivo)

  getProductPriceWithVat(product: IProduct, quantity = 1): number {
    const unitBaseAmount = product.price;
    const unitWithVat = unitBaseAmount + (unitBaseAmount * this.getProductVatRate(product) / 100);
    let roundedUnitWithVat = unitWithVat;
    if (this.sessionService.currentUser()?.defaultcompany?.rounded_price) {
       roundedUnitWithVat = Math.ceil(unitWithVat);
    }
    return roundedUnitWithVat * quantity;
  }

  // Conteggio totale delle quantità prodotto in carrello.

  itemCount = computed(() => {
    return this.items().reduce((sum, item) => sum + item.quantity, 0);
  });

  // Calcolo  importo totale per prodotto netto

  subtotal_net = computed (()=>{
    const netto= this.items().reduce((sum, item) => {
      const importo_ivato_riga =this.getProductPriceWithVat(item.product, item.quantity);
      const importo_netto_riga =  Math.round((importo_ivato_riga/(1+this.getProductVatRate(item.product) / 100)) * 100) / 100;
      return sum + importo_netto_riga;
    },0);
    console.log("subtotal_net:",netto);
    return netto??0;
  });

  //Calcolo iva sulla spedizione

  vat_shipping = computed(() => {
    const ivas:number = this.shippingCost()* this.iva_shipping() / 100;
    console.log("iva shipping:",ivas);
    return ivas;
  });

  //Calcolo iva su accise

  vat_fees =computed(() => {
    const ivas = this.fees()* this.iva() / 100;
    console.log("iva accise:",ivas);
    return ivas;
  })

  //Calcolo iva totale =alla somma delle ive prodotti (secondo il loro rate) +quelle di accise e spedizioni

  vat_total = computed(() => {
    const vat_prodotti =  this.items().reduce((sum, item) => {
      const importo_ivato_riga =this.getProductPriceWithVat(item.product, item.quantity);
      const importo_netto_riga =  Math.round(importo_ivato_riga/(1+this.getProductVatRate(item.product) / 100)  * 100) / 100;
      return sum + (importo_netto_riga * this.getProductVatRate(item.product) / 100);
    },0);
    console.log("iva prodotti:",vat_prodotti);
    const totale =Math.round( (this.vat_shipping() + this.vat_fees()+vat_prodotti)*100)/100;
    console.log("iva totale:",totale);
    return totale;
  })

  // Calcolo totale lordo ivato

  Gross_Total = computed(() => {
    const total= (this.vat_total()??0)+(this.subtotal_net()??0)+this.shippingCost()+this.fees();
    console.log("Gross_Total:",total);
    return total;
  })

  // Esposizione grafica dell'rate iva

  ivaesposta= computed(() => {
    let _iva = this.iva();
    if (_iva === 0) return '';
    const items_reduced = this.items().filter(item => item.product.tax_rate != 'standard');
    if (items_reduced.length > 0 && (this.iva_reduced()>0 || this.iva_reduced_2()>0)) { return ''}
    return `(${_iva}%)`;
  })

  //Calcolo importo netto di riga

  getTotalNetItem(product: IProduct, quantity:number ): number {
    const unitBaseAmount = product.price;
    const unitWithVat = unitBaseAmount + (unitBaseAmount * this.getProductVatRate(product) / 100);
    let roundedUnitWithVat = unitWithVat;
    if (this.sessionService.currentUser()?.defaultcompany?.rounded_price) {
      roundedUnitWithVat = Math.ceil(unitWithVat);
    }
    const totalelordoRiga= roundedUnitWithVat * quantity;
    const importoNetto =Math.round(totalelordoRiga/(1+this.getProductVatRate(product) / 100)*100)/100;
    console.log("Importo netto riga",importoNetto);
    return importoNetto;
  }

  //Calcolo importo sconto

  importo_sconto = computed(() => {
    return this.Gross_Total() * this.sconto() / 100;
  });

  applyVatRates(country: ICountry | null): void {
    const isUsaVatExempt =
      country?.iso_code?.toUpperCase() === 'US' &&
      this.sessionService.currentUser()?.defaultcompany?.vat_exemption_usa === true;

    if (isUsaVatExempt) {
      this.iva.set(0);
      this.iva_shipping.set(0);
      this.iva_reduced.set(0);
      this.iva_reduced_2.set(0);
      return;
    }

    this.iva.set(country?.vat ?? 0);
    this.iva_shipping.set(country?.vat_shipping ?? 0);
    this.iva_reduced.set(country?.vat_reduced ?? 0);
    this.iva_reduced_2.set(country?.vat_reduced_2 ?? 0);
  }

  constructor() {
    effect(() => {
      const country = this.sessionService.CurrentCountry();
      this.applyVatRates(country);
    });

    this.loadCart();
    toObservable(this.items)
        // Use takeUntilDestroyed to automatically unsubscribe
        .pipe(takeUntilDestroyed())
        .subscribe((newUser) => {
          // This code will run when the signal value changes
          this.shippingCost.set(0);
          this.fees.set(0);
        });
  }

  getOrderID():string {
    const nome = this.customerinfo().name+' '+this.customerinfo().surname;
    const id = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
    const iniziali = nome.split(' ').map(parola => parola.charAt(0)).join('');
    let newId ="DFI#"+`${iniziali}-${id}`;
    this.ordine_id.set(newId);
    return newId;
  }

  addItem(product: IProduct, quantity: number): void {
    this.items.update(items => {
      const existing = items.find(item => item.product.id === product.id);
      if (existing) {
        return items.map(item =>
          item.product.id === product.id
            ? { ...item, quantity: item.quantity + quantity }
            : item
        );
      }
      return [...items, { product, quantity }];
    });
    this.saveCart();
  }

  removeItem(productId: string): void {
    this.items.update(items => items.filter(item => item.product.id !== productId));
    this.saveCart();
  }

  updateQuantity(productId: string, delta: number): void {
    this.items.update(items => {
      return items
        .map(item =>
          item.product.id === productId
            ? { ...item, quantity: Math.max(0, item.quantity + delta) }
            : item
        )
        .filter(item => item.quantity > 0);
    });
    this.saveCart();
  }

 InitCart(isshipped:boolean){
   this.customerinfo.set(this.defaultShippingValues);
   this.ordine_id.set(null);
   this.shippingCost.set(0);
   this.fees.set(0);
   this.iva_shipping.set(0);
   this.insuranceEnabled.set(false);
   this.shipaddressConfirmed.set(false);
   this.isshippinginfoValid.set(false);
   this.sconto.set(0);
   console.log('InitCart called with noshipped:', isshipped);
   if (isshipped) {
     console.log('azzero iva normale');
     this.iva.set(0);
     this.iva_reduced.set(0);
     this.iva_reduced_2.set(0);
   }
   this.payment.set('cash');
 }

  clearCart(): void {
    this.InitCart(false);
    this.items.set([]);
    this.saveCart();
  }

  CalcolaSconto(){
    //Todo richiesta sconto da parte del server
    if (!this.isscontato()) {
     // this.sconto.set(10);
    }
  }

  private saveCart(): void {
    localStorage.setItem('gourmet-cart', JSON.stringify(this.items()));
  }

  private loadCart(): void {
    const saved = localStorage.getItem('gourmet-cart');
    if (saved) {
      try {
        this.items.set(JSON.parse(saved));
      } catch (e) {
        console.error('Failed to load cart from localStorage', e);
        this.items.set([]);
      }
    }
  }
}
